<template>
  <div>
    <!-- Header -->
    <div class="py-3 mb-3 border-bottom">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-6 d-flex">
                    <h5 class="m-0 p-0 align-self-center">
                        Revisões
                    </h5>
                </div>
                <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                   

                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <b-card class="mb-4">
            <!-- Load Table -->
            <b-skeleton-wrapper :loading="loading">

            <!-- Loading -->
            <template #loading>
                <b-skeleton-table
                    :rows="6"
                    :columns="6"
                    :table-props="{ bordered: true, striped: true }"
                >
                </b-skeleton-table>
            </template>

            <!-- Table -->
            <b-table
                id="tasksTable"
                :items="table"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                @sort-changed="changeSortable"
                empty-text="Não encontramos nenhum resultado na busca :("
                class="bg-white mb-0"
                stacked="md"
                :sticky-header="true"
                show-empty
                no-local-sorting
                bordered
                hover>

                <template v-slot:cell(observations)="row">
                    {{ row.item.observations | truncate(20) }}
                </template>

                <template v-slot:cell(teacher.name)="row">
                    <span v-if="row.item.teacher.name">
                        <span v-if="row.item.teacher.name" v-b-tooltip.hover :title="row.item.teacher.name">
                            {{ row.item.teacher.name | truncate(20) }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </span>
                    <span v-else>
                        ---
                    </span>
                </template>

                <template v-slot:cell(essay.teacher)="row">
                    <span v-if="row.item.essay.teacher">
                        <span v-if="row.item.essay.teacher.name" v-b-tooltip.hover :title="row.item.essay.teacher.name">
                            {{ row.item.essay.teacher.name | truncate(20) }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </span>
                    <span v-else>
                        ---
                    </span>
                </template>
                

                <template v-slot:cell(status)="row">
                    <span v-if="row.item.status === 'draft'" class="text-info px-2 py-1 rounded-pill" style="background-color: #0dcaf010">
                        Rascunho
                    </span>

                    <span v-if="row.item.status === 'finished'" class="text-success px-2 py-1 rounded-pill" style="background-color: #19875410">
                        Finalizada
                    </span>

                </template>

                <template v-slot:cell(created_at)="row">
                    <span v-b-tooltip.hover :title="row.item.created_at | moment('DD/MM/YYYY HH:mm')">
                        {{ row.item.created_at | moment('from', 'now') }}
                    </span>
                </template>

                <template v-slot:cell(finished_review)="row">
                    <span v-if="row.item.finished_review">
                        {{ row.item.finished_review | moment('DD/MM/YYYY HH:mm') }}
                    </span>
                    <span v-else>
                        ---
                    </span>
                </template>

                <template v-slot:cell(essay.status)="row">
                    <span v-if="row.item.essay.status === 'BLOCK'" class="text-warning px-2 py-1 rounded-pill" style="background-color: #ffc10710">
                        Aguardando Devolução
                    </span>

                    <span v-if="row.item.essay.status === 'WAIT'" class="text-danger px-2 py-1 rounded-pill" style="background-color: #dc354510">
                        Aguardando
                    </span>

                    <span v-if="row.item.essay.status === 'IN_PROGRESS'" class="text-info px-2 py-1 rounded-pill text-nowrap" style="background-color: #0dcaf010">
                         Em Andamento
                    </span>

                    <span v-if="row.item.essay.status === 'OKAY'" class="text-success px-2 py-1 rounded-pill" style="background-color: #19875410">
                        Corrigida
                    </span>

                </template>

                <template v-slot:cell(actions)="row">

                    <div class="text-center d-flex">

                        <!-- Details -->
                        <a href="javascript:void(1);" class="mr-2" @click="showDetails(row.item)" v-b-tooltip.hover title="Ver Revisão">
                            <i class="fas fa-eye"></i>
                        </a>

                        <a href="javascript:void(1);" class="mr-2" v-if="row.item.essay.status != 'OKAY' && canChangeRevisor" @click="editTeacher(row.item)" v-b-tooltip.hover title="Alterar revisor">
                            <i class="fas fa-edit"></i>
                        </a>

                        <a v-if="row.item.essay.status != 'OKAY'" :href="'/teacher/essays/' + row.item.essay_id + '/correction'" class="text-info"  :disabled="loading" target="_blank" v-b-tooltip.hover title="Acessar correção">
                            <svg  height="20px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                        </a>
                        
                    </div>

                </template>

            </b-table>
        </b-skeleton-wrapper>
        </b-card>

        <!-- Paginate -->
        <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            @change="changePagination"
        />
    </div>

    <review-modal></review-modal>

    <review-teacher-modal @updated="load" :teachers="teachers"></review-teacher-modal>

  </div>
</template>

<script>
import ReviewModal from '../essays/ReviewModal.vue';
import ReviewTeacherModal from './ReviewTeacherModal.vue';

export default {
    components: {
        ReviewModal,
        ReviewTeacherModal
    },
    props: ['teachers', 'canChangeRevisor'],
    data(){
        return {
            loading: false,
            currentPage: 1,
            total: 0,
            perPage: 10,
            table: [],
            sortBy: 'created_at',
            sortDesc: false,
            fields: [
                { key: 'observations', label: 'Observações'},
                { key: 'status', label: 'Status'},
                { key: 'teacher.name', label: 'Revisor'},
                { key: 'essay.teacher', label: 'Corretor'},
                { key: 'essay.status', label: 'Status da Redação'},
                { key: 'finished_review', label: 'Finalizada', sortable: true},
                { key: 'created_at', label: 'Criada', sortable: true },
                { key: 'actions', label: '' }
            ],
        }
    },
    created(){
        this.load();
    },
    methods: {
        load() {
            this.loading = true;

            axios.get('/teacher/reviews', {
                params: {

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.reviews.data
                    this.currentPage = response.reviews.current_page
                    this.perPage = response.reviews.per_page
                    this.total = response.reviews.total


                })
                .finally(() => this.loading = false)
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },
        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        showDetails(review) {
            this.$root.$emit('ReviewEssay', review);
        },

        editTeacher(review) {
            this.$root.$emit('ReviewTeacher', review);
        }
    }
}
</script>

<style>

</style>